import React from "react";
import "../components/componentstyle/chageableHeader.css";
import heroImg from "../assets/hero-img-2.jpg";

function ChangeAlbeHeader({ children }) {
  return (
    <div>
      <div className="about-section">
        <div className="bg-about-img">
          <img
            src={heroImg}
            alt="About Background"
            className="about-bg-image"
          />
        </div>
        <div className="overlay">
          <h1>{children}</h1>
        </div>
      </div>
    </div>
  );
}

export default ChangeAlbeHeader;
